module.exports = __webpack_public_path__ + "static/media/poste_28.5daac50f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_28.jpg
// module id = 257
// module chunks = 0